import axios from 'axios'
import { URL } from '../../../util/ambienteActions';

const baixarComprovanteTransferencia = (comprovanteTransferencia, nomeComprovanteTransferencia) => axios({
    url:`${URL}/arquivo/id/${comprovanteTransferencia}/nome/${nomeComprovanteTransferencia}/baixar`,
    method: 'GET',
    responseType: 'blob'
    })

export default baixarComprovanteTransferencia